import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowLeft, Loader2, AlertCircle } from "lucide-react";
import { STRIPE_PRICES, PRO_FEATURES } from "../constants/pricing";
import { startCheckout } from "../services/checkoutService";

export default function CheckoutPage() {
  const [cycle, setCycle] = useState("monthly");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const price = cycle === "yearly" ? "€199" : "€19";
  const period = cycle === "yearly" ? "/anno" : "/mese";

  const handleUpgrade = async () => {
    setError(null);
    setLoading(true);
    try {
      await startCheckout(STRIPE_PRICES[cycle]); // redirect a Stripe
    } catch (e) {
      console.error("Checkout error:", e);
      setError("Impossibile avviare il pagamento. Riprova tra poco.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 bg-gradient-to-br from-forfy-50 via-white to-neutral-50">
      <div className="w-full max-w-md">
        <Link to="/dashboard" className="inline-flex items-center gap-1.5 text-sm text-neutral-500 hover:text-neutral-700 mb-6">
          <ArrowLeft className="w-4 h-4" /> Torna alla dashboard
        </Link>

        <div className="rounded-2xl shadow-xl border border-neutral-100 bg-white p-8">
          <h1 className="text-2xl font-display font-semibold text-neutral-900 text-center">Passa a Forfy Pro</h1>
          <p className="mt-2 text-sm text-neutral-500 text-center">Tutte le funzionalità, senza limiti. Disdici quando vuoi.</p>

          {/* Toggle mensile / annuale */}
          <div className="mt-6 flex w-fit mx-auto p-1 rounded-full bg-forfy-50 border border-forfy-100">
            <button
              type="button"
              onClick={() => setCycle("monthly")}
              className={`px-5 py-1.5 rounded-full text-sm font-medium transition-colors ${cycle === "monthly" ? "bg-forfy-500 text-white shadow" : "text-neutral-600"}`}
            >
              Mensile
            </button>
            <button
              type="button"
              onClick={() => setCycle("yearly")}
              className={`px-5 py-1.5 rounded-full text-sm font-medium transition-colors ${cycle === "yearly" ? "bg-forfy-500 text-white shadow" : "text-neutral-600"}`}
            >
              Annuale
            </button>
          </div>

          {/* Prezzo */}
          <div className="mt-6 text-center">
            <span className="text-4xl font-display font-bold text-neutral-900">{price}</span>
            <span className="text-neutral-500 ml-1">{period}</span>
            {cycle === "yearly" && <p className="mt-1 text-sm font-medium text-forfy-600">Risparmi €29 all'anno</p>}
          </div>

          {/* Feature */}
          <ul className="mt-6 space-y-2.5">
            {PRO_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-neutral-700">
                <Check className="w-4 h-4 mt-0.5 shrink-0 text-forfy-600" strokeWidth={2.5} /> {f}
              </li>
            ))}
          </ul>

          {error && (
            <div className="mt-5 flex items-start gap-2 p-3 rounded-lg bg-red-50 border border-red-200">
              <AlertCircle className="w-4 h-4 mt-0.5 shrink-0 text-red-600" />
              <p className="text-sm text-red-700">{error}</p>
            </div>
          )}

          <button
            onClick={handleUpgrade}
            disabled={loading}
            className="mt-6 w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg font-medium text-sm bg-forfy-600 text-white hover:bg-forfy-700 disabled:opacity-60 transition-colors"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {loading ? "Reindirizzamento…" : "Passa a Pro"}
          </button>

          <p className="mt-4 text-center text-xs text-neutral-400">
            Pagamento sicuro gestito da Stripe. Nessun dato di pagamento transita da Forfy.
          </p>
        </div>
      </div>
    </div>
  );
}
